var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.equipmentCategory === null)?_c('v-card',{attrs:{"loading":"plywood"}},[_c('v-card-title')],1):[(
                _vm.equipmentCategory === _vm.config.VeneerProductionEquipment ||
                    _vm.equipmentCategory === _vm.config.VeneerProcessingEquipment
            )?_c('c-flex-grid',{attrs:{"url-path":_vm.$api.journals.planResByShiftEquipmentVeneerProcessGroupItem,"url-query":{
                idPlanRes: _vm.idPlanRes,
                shiftIndex: _vm.shiftIndex,
                idEquipmentType: _vm.idEquipmentType,
            },"subcomponent":_vm.veneerSubcomponent,"sortable":"","is-compressed":_vm.params.isCompressed}}):_c('c-flex-grid',{attrs:{"url-path":_vm.$api.journals.planResByShiftPlywoodEquipmentGroupPlywood,"url-query":{
                idPlanRes: _vm.idPlanRes,
                shiftIndex: _vm.shiftIndex,
                idEquipmentType: _vm.idEquipmentType,
            },"subcomponent":_vm.plywoodSubcomponent,"sortable":"","is-compressed":_vm.params.isCompressed}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }